'use client';

import { Fragment } from 'react';

import { itemsEmptyCheck } from '@nf/utils-common/fpw/utils';

interface HighlighterProps {
	text?: string;
	highlightWords?: Array<string>;
	className?: string;
}

const createHighlightWordsPattern = (highlightWords: Array<string>) => 
	itemsEmptyCheck(highlightWords)
		.map((words: Array<string>) => words.join('|'));

const isEqualsHighlight = (text: string) => (highlight: string) => 
	text.toLowerCase() === highlight.toLowerCase();

export const Highlighter = ({ 
	text = '', 
	highlightWords = [], 
	className 
}: HighlighterProps) => {
	const parts: Array<string> = createHighlightWordsPattern(highlightWords).fold(
		() => [text],
		(wordsPattern: string) => text
			.split(new RegExp(`(${wordsPattern})`, 'gi'))
			.filter(Boolean)
	);

	return (
		<>
			{parts.map((part, idx) => (
				highlightWords.some(isEqualsHighlight(part))
					? (
						<span 
							key={idx}
							className={className}
						>
							{part}
						</span>
					)
					: <Fragment key={idx}>{part}</Fragment>
			))}
		</>
	);
};